import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const nav = useNavigate();
  const from = useLocation().state?.from;

  const submit = async (e) => {
    e.preventDefault();
    const r = await login(email, password);
    if (r.ok) { toast.success("Welcome back!"); nav(from?.startsWith("/product/") ? from : "/"); }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-[70vh] grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1680713660046-67b7350ed679?w=1200&q=80" alt="Ghana market" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1E4D3B]/70 to-transparent" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <div className="text-xs uppercase tracking-widest font-bold text-[#D99B26]">AgriNuhse</div>
          <h2 className="text-3xl font-black mt-2">Welcome back to the farm.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="login-form">
          <h1 className="text-3xl font-extrabold text-[#1E4D3B]">Sign in</h1>
          <p className="text-sm text-[#5C6660]">Buy fresh produce or manage your farm listings.</p>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg" data-testid="login-email-input" />
          </div>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg" data-testid="login-password-input" />
          </div>
          <button className="btn-primary w-full py-3 rounded-xl" data-testid="login-submit-button">Sign in</button>
          <div className="text-sm text-center text-[#5C6660]">
            No account? <Link to="/register" className="text-[#C85A32] font-semibold">Create one</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
